<template>
  <div>
    <div class="app" v-cloak>
      <!--      <transition :name="transitionName">-->
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
      <!--      </transition>-->
    </div>
    <!-- <Footer v-if="footer === true"></Footer>
    <Home v-if="home === true"></Home> -->
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}
// import Footer from "@components/Footer";
// import Home from "@components/Home";
import { mapGetters } from "vuex";
import { getDict } from "@api/admin";
import { getCity } from "@api/user";
import { getOrderList } from "@api/order";
import ws from "@/utils/ws";

export default {
  data() {
    return {
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: [],
      ws: null,
    };
  },
  provide() {
    return {
      app: this,
    };
  },
  created() {
    this.$route.query.channelid &&
      sessionStorage.setItem("channelid", this.$route.query.channelid);
    this.getDictList();
  },
  mounted() {
    this.isLogin && this.orderRefesh();
    this.$nextTick(() => {
      // if (this.$route.path === "Login") return;
      if (
        this.$route.path.indexOf("/game") == -1 ||
        this.$route.path == "/game/my"
      ) {
        if (!this.ws) {
          this.createWs();
        }
      }
      // this.createWs();
    });
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  watch: {
    $route: {
      handler(to, from) {
        const lastPath = this.history[this.history.length - 1] || {},
          { isReplace, isBack } = this.$router;

        if (lastPath.path === to.path) {
          this.transitionName = "fold-right";
          this.history.pop();
        } else {
          this.transitionName = "fold-left";
          if (!isReplace)
            this.history.push({ path: from.path, name: from.name });
        }

        if (isKeepAlive(to) && to.name !== "Login") {
          !this.include.includes(to.name) && this.include.push(to.name);
        }

        if (isKeepAlive(from) && isBack) {
          var index = this.include.indexOf(from.name);
          index !== -1 && this.include.splice(index, 1);
        }

        this.$router.isBack = false;
        this.$router.isReplace = false;
        if (to.path.indexOf("/game") == -1 || this.$route.path == "/game/my") {
          // console.log("开始创建", to.path, to);
          this.closeWs();
          this.createWs();
        } else {
          this.closeWs();
        }
      },
    },
  },
  methods: {
    async getDictList() {
      const arr = ["sex_code", "meet_type"];
      let dictObj = {};
      for (let i = 0; i < arr.length; i++) {
        const res = await getDict({ name: arr[i] });
        dictObj[arr[i]] = {};
        res.data.forEach((item) => {
          dictObj[arr[i]][item.value] = item.label;
        });
      }
      const priceData = await getDict({ name: "first_price" });
      dictObj["first_price"] = priceData.data[0].value;
      this.$store.commit("SET_DICT", dictObj);
      const resAddress = await getCity();
      let ad = {};
      resAddress.data.forEach((item) => {
        !ad[item.v] && (ad[item.v] = {});
        (item.c || []).forEach((ele) => {
          ad[item.v][ele.v] = ele.n;
        });
      });
      let addressOption = resAddress.data.map((item) => {
        return {
          n: item.n,
          v: item.v,
          c: item.c.map((ele) => ({ n: ele.n, v: ele.v })),
        };
      });
      this.$store.commit("SET_CITY_OBJECT", ad);
      this.$store.commit("SET_CITY", addressOption);
      const firstData = await getDict({ name: "first_num" });
      const num =
        firstData.data && firstData.data[0] ? firstData.data[0].value : 1;
      this.$store.commit("SET_FIRST_NUM", num);
    },
    orderRefesh() {
      // getOrderList({ type: 10, userCategory: 1 }).then((res) => {
      //   const l = res.data;
      //   this.$store.commit("SET_REFRESH_BUY_NUM", l.length);
      // });

      // getOrderList({ type: 10, userCategory: 2 }).then((res) => {
      //   const l = res.data;
      //   this.$store.commit("SET_REFRESH_CUSTOMER_NUM", l.length);
      // });
    },
    getUserInfo() {
      // $store.dispatch("USERINFO").then(() => {
      let userInfo = this.$store.state.app.userInfo;
      return new Promise(async (resolve, reject) => {
        // 进入准备获取
        if (userInfo) {
          // 直接由开始返回
          resolve(userInfo);
        } else {
          // 开始返回
          await this.$store.dispatch("USERINFO");
          userInfo = this.$store.state.app.userInfo;
          resolve(userInfo);
        }
      });
    },
    wsMessage(data) {
      const dataJson = data;
      // 用户被教练邀请
      if (dataJson.type == 6) {
        this.$dialog.confirm({
          mes: "有教练邀请您参加游戏，是否进入该游戏？",
          opts: () => {
            this.closeWs();
            this.$router.push({
              path: "/game/choose",
              query: {
                gameId: dataJson.gameId,
              },
            });
          },
        });
      }
    },
    async createWs() {
      if (this.isLogin) {
        const userInfo = await this.getUserInfo();
        // this.closeWs();
        this.ws = new ws({
          url: `/game/0/${userInfo.uid}`,
          //心跳时间（单位:ms）
          heartBeat: 5000,
          //发送心跳信息（支持json传入）
          heartMsg: {
            roomId: 0,
            userId: userInfo.uid,
            heartbeat: "ping",
          },
          //开起重连
          reconnect: true,
          //重连间隔时间（单位:ms）
          reconnectTime: 5000,
          //重连次数
          reconnectTimes: 5,
        });
        this.ws //接收信息
          .onmessage((data) => {
            if (data == "pong") {
              // return;
            } else {
              this.wsMessage(JSON.parse(data));
            }
          });
      }
    },
    closeWs() {
      if (this.ws) {
        this.ws.close();
        this.ws.ws.close();
        this.ws = null;
        // 销毁ws
      }
    },
  },
};
</script>
<style lang="scss">
[v-cloak] {
  display: none !important;
}

.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.html-content {
  img {
    max-width: 100%;
  }
}
</style>
